export const environment = {
  production: false,
  api: {
    BE: 'https://staging-metafora-ctm.flosslab.com/api',
    metafora: 'https://staging-metafora-ctm.flosslab.com/api-metafora/public/v1/'
  },
  odoo: {
    login: "service@example.com",
    password: "Area51Documentale!"
  },
  metafora: {
    apiKey: "c8b35c23c3c4d290a1511e47472b6aeb92214704"
  }
};
